<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Movimentação Mínima"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalAtualizarMovimentacao"
			hide-footer
		>
			<div slot="modal-title">
				Movimentações Mínimas -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<movimentacoes-form
				tipoOperacao="a"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterMovimentacoesAtualizadas="$emit('obterMovimentacoesAtualizadas')"
				:contrato="contrato"
				:movimentacaoMinimaId="movimentacaoMinimaId"
				:movimentacao="movimentacao"
				:unidadesDeMedida="unidadesDeMedida"
			></movimentacoes-form>
		</b-modal>
    </div>
</template>

<script>
import MovimentacoesForm from './MovimentacoesForm'

export default {
	components: {
		MovimentacoesForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		movimentacaoMinimaId: {
            type: String,
            default: () => ('')
        },

		movimentacao: {
			type: Object,
			default: () => ({})
		},

		unidadesDeMedida: {
			type: Array
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
			console.log(this.movimentacao)
		}
	},

	created() {},

	mounted() {
	},

	computed: {},

	watch: {},

	validations: {}
}
</script>
